import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-video-icons-previous"] || "codicon-video-icons-previous")} viewBox="0 0 21 27" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="nonzero"><path d="M20.626 2.658L3.405 13.721l17.221 11.063z" /><path d="M4.487.721h-4v26h4z" /></g></svg>;